
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CalendarDays, AlertCircle } from 'lucide-react';
import { fetchAttendanceCard } from '../../store/slices/attendanceSlice';
import EmployeePicker from './EmployeePicker';
import MonthNavigator from './MonthNavigator';
import AttendanceCardView from './AttendanceCardView';
import TodayAttendancePanel from './TodayAttendancePanel';

function currentMonth() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export default function AttendanceExplorer({ employees, extra }) {
  const dispatch = useDispatch();
  const [serviceNo, setServiceNo] = useState(null);
  const [month, setMonth] = useState(currentMonth());
  const { rows, loading, error, serviceNo: loadedFor, month: loadedMonth } =
    useSelector((s) => s.attendance);

  useEffect(() => {
    if (!serviceNo) return;
    dispatch(fetchAttendanceCard({ serviceNo, month }));
  }, [serviceNo, month]);

  const isCurrent = serviceNo && loadedFor === serviceNo && loadedMonth === month;

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3 flex-wrap">
        <EmployeePicker employees={employees} value={serviceNo} onSelect={setServiceNo} />
        {serviceNo && <MonthNavigator month={month} onChange={setMonth} />}
        {extra}
      </div>

      {!serviceNo ? (
        <TodayAttendancePanel employees={employees} onSelectEmployee={setServiceNo} />
      ) : loading || !isCurrent ? (
        <div className="flex flex-col items-center justify-center py-16 gap-3">
          <div className="w-9 h-9 border-4 border-slate-300 border-t-slate-700 rounded-full animate-spin" />
          <p className="text-sm text-gray-500">Loading attendance...</p>
        </div>
      ) : error ? (
        <div className="flex items-center gap-2 px-4 py-3 bg-red-50 border border-red-200 rounded-xl text-red-700 text-sm">
          <AlertCircle size={14} className="shrink-0" /> {error}
        </div>
      ) : (
        <AttendanceCardView rows={rows} month={month} />
      )}
    </div>
  );
}
